export const uploadFileToChatgpt = async (file) => {
  const form = new FormData();
  form.append("file", file);
  const response = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/chatgpt/files`,
    {
      method: "POST",
      body: form,
    }
  );
  const { openAifileId } = await response.json();
  return openAifileId;
};
